import React from 'react';
import { Link } from 'react-router-dom';
import './FeaturedProjects.css';

const featuredProjects = [
  {
    id: 1,
    slug: "modern-villa-electrical",
    title: "Modern Villa Electrical System",
    type: "Residential Installation",
    image: "/images/projects/project-1.jpg"
  },
  {
    id: 2,
    slug: "commercial-solar-farm",
    title: "Commercial Solar Farm Setup",
    type: "Solar Systems",
    image: "/images/projects/project-2.jpg"
  },
  {
    id: 3,
    slug: "factory-cctv-security",
    title: "Factory CCTV & Security Network",
    type: "Security Systems",
    image: "/images/projects/project-3.jpg"
  },
  {
    id: 4,
    slug: "hotel-network-infrastructure",
    title: "Hotel Network Infrastructure",
    type: "Network Installation",
    image: "/images/projects/project-4.jpg"
  }
];

const FeaturedProjects = () => {
  return (
    <section className="featured-projects">
      <div className="fp-container">
        <div className="fp-header">
          <h4 className="fp-subtitle">Our Work</h4>
          <h2 className="fp-title">Featured Projects</h2>
          <p className="fp-description">Explore some of our recent electrical and installation projects</p>
        </div>
        <div className="fp-grid">
          {featuredProjects.map((project) => (
            <Link to={`/projects/${project.slug}`} className="fp-card" key={project.id}>
              <div className="fp-image">
                <img src={process.env.PUBLIC_URL + project.image} alt={project.title} />
                <span className="fp-tag">{project.type}</span>
              </div>
              <div className="fp-info">
                <h3>{project.title}</h3>
                <span className="fp-arrow">→</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedProjects;
